export const formatBedrooms = (n: number): string => {
  if (!Number.isFinite(n)) return "—";
  if (n === 0) return "Studio";
  return n === 1 ? "1 Bed" : `${n} Beds`;
};

export const formatBathrooms = (n: number): string => {
  if (!Number.isFinite(n)) return "—";
  const formatted = Number.isInteger(n) ? String(n) : n.toFixed(1);
  return n === 1 ? `${formatted} Bath` : `${formatted} Baths`;
};

export const formatBedsBaths = (beds: number, baths: number): string => {
  if (beds === 0) return `Studio | ${formatBathrooms(baths)}`;
  return `${formatBedrooms(beds)} | ${formatBathrooms(baths)}`;
};

export const currency = (n: number, digits = 0): string =>
  `$${n.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;

export const shortDate = (iso: string | null): string => {
  if (!iso) return "—";
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
